export default {
  PNP_1: {
    title: 'Total Owned and Earned Posts',
    description: 'Sum of proprietary and non-proprietary posts collected in the research.',
  },
  PNP_2: {
    title: 'Sentiment Reach by Tag Owned + Earned',
    description: 'Sum of reach and distribution of proprietary and non-proprietary posts by research-registered Tags and their polarity breakdown.',
  },
  PNP_3: {
    title: 'Sentiment by Term Owned + Earned',
    description: 'Sum of the distribution of proprietary and non-proprietary posts by most mentioned terms and their polarity breakdown.',
  },
  PNP_4: {
    title: 'Sentiment by Theme Owned + Earned',
    description: 'Sum of the distribution of proprietary and non-proprietary posts by most mentioned research-registered Themes and their polarity breakdown.',
  },
  PNP_5: {
    title: 'Brand Health Owned + Earned',
    description: 'Represents, as a gauge, the result of the equation: (positive owned and earned posts / total collected owned and earned posts * 100) - (negative owned and earned posts / total collected owned and earned posts * 100).',
  },
  PNP_6: {
    title: 'Distribution by Channel Owned + Earned',
    description: 'Division of posts by proprietary and non-proprietary collection channel.',
  },
  PNP_7: {
    title: 'Total Users for Owned and Earned',
    description: 'Count of unique users who generated total proprietary and non-proprietary posts in the research.',
  },
  PNP_8: {
    title: 'Potential Reach for Owned and Earned',
    description: 'Represents 20% of the sum of followers/subscribers of profiles collected for proprietary and non-proprietary posts.',
  },
  PNP_9: {
    title: 'Posts by Tag for Owned and Earned',
    description: 'Distribution of posts by assigned tags for Owned and Earned.',
  },
  PNP_10: {
    title: 'Total Unique Owned and Earned Posts',
    description: 'Sum of unique proprietary and non-proprietary posts collected in the research.',
  },
  PNP_11: {
    title: 'Sentiment Over Time for Posts and Interactions',
    description: 'Distribution of the sum of posts and received interactions by polarity over a time period.',
  },
  PNP_12: {
    title: 'Posts by Tag Over Time',
    description: 'Distribution of the sum of proprietary and non-proprietary posts by research-assigned Tags over time.',
  },
  PNP_13: {
    title: 'Posts Over Time',
    description: 'Linear distribution of the sum of posts and interactions from Listening + Proprietary Metrics collected over a time period.',
  },
  PNP_14: {
    title: 'Sentiment Distribution',
    description: 'Sum of posts and interactions (Listening + Proprietary Metrics) divided by positive, negative, or neutral polarity.',
  },
  PNP_15: {
    title: 'Post Sampling Projection',
    description: 'Projection of sampled posts for Listening + Proprietary Metrics.',
  },
  PNP_16: {
    title: 'Total Posts, Shares, and Comments',
    description: 'Sum of proprietary and non-proprietary posts, shares, and comments.',
  },
  PNP_17: {
    title: 'Total Posts, Shares, and Comments Over Time',
    description: 'Distribution of the sum of proprietary and non-proprietary posts, shares, and comments over time.',
  },
};
